import { ApiPortfolioState } from '../../dashboard/models/ApiPortfolioState';
import FeatureAccessService from '../../shared/services/FeatureAccessService';
import { LessonDisplayMode } from '../../content/models/LessonComponent';
import { LessonType } from '../models/LessonVm';

class LessonService {
  public isAutoMarkingLesson(lessonType: LessonType) {
    switch (lessonType) {
      case 'quiz':
      case 'lesson':
        return true;
      default:
        return false;
    }
  }

  public showCommentMenu(mode: LessonDisplayMode, state: ApiPortfolioState) {
    return (
      mode === 'mark' ||
      (mode === 'learn' &&
        (state === ApiPortfolioState.AssessmentRetry ||
          state === ApiPortfolioState.AssessmentLock))
    );
  }

  public disableCommentMenu(mode: LessonDisplayMode, assignedToMe: boolean) {
    //disable comment menu for regular markers if the assessment is not assigned to them.
    return (
      mode === 'mark' &&
      !FeatureAccessService.hasMasterAccess &&
      !FeatureAccessService.hasMasterMarkerAccess &&
      !assignedToMe
    );
  }
}

export default new LessonService();
